(() => {
  const start = () => {
    const purchase = document.querySelector('[data-ka-sunset-mini-purchase]');
    if (!purchase || purchase.dataset.ready !== 'true') return false;
    if (purchase.dataset.kaMiniCardsReady === 'true') return true;
    const region = purchase.closest('[data-mini-product-region]');
    const form = region?.querySelector('form[action*="/cart/add"]');
    const wrapping = purchase.querySelector('[data-mini-wrapping]');
    const noshi = purchase.querySelector('[data-mini-noshi]');
    const noshiFields = purchase.querySelector('[data-mini-noshi-fields]');
    const noshiInput = noshiFields?.querySelector('[data-mini-noshi-content]');
    const summary = purchase.querySelector('.ka-sunset-mini-purchase__summary');
    const points = purchase.querySelector('[data-mini-points]');
    const gift = purchase.querySelector('.ka-sunset-mini-purchase__gift-grid');
    if (!region || !form || !wrapping || !noshi || !noshiFields || !noshiInput || !summary || !points || !gift) return false;
    purchase.dataset.kaMiniCardsReady = 'true';
    region.classList.add('ka-mini-price-list');
    purchase.id = 'ka-mini-purchase-options';
    const variants = JSON.parse(purchase.querySelector('[data-mini-variants-json]').textContent);
    const card = document.createElement('div');
    card.className = 'ka-mini-size-card';
    card.innerHTML = '<h2>サイズ</h2><div><strong>ミニ</strong><span>約21 × 17.5cm</span><b></b></div>';
    card.querySelector('b').textContent = new Intl.NumberFormat('ja-JP').format(variants[0].price / 100) + '円';
    purchase.prepend(card);
    // 9/27：ミニは名前・メッセージ入れの対象外であることをサイズのすぐ下で案内し、同じ絵の通常サイズ（Sサイズ以上）の商品ページへつなぐ（ユーザー決定）
    const miniHandle=(location.pathname.match(/\/products\/([^/?#]+)/)||[])[1]||'';
    if(/-mini$/.test(miniHandle)){
      const notice=document.createElement('p');notice.className='ka-mini-message-notice';
      notice.innerHTML='※名前・メッセージ入れは、Sサイズ以上で承ります（ミニサイズは対象外です）。<a class="ka-mini-message-notice__link">この絵のSサイズ以上を見る ›</a>';
      notice.querySelector('a').href=(window.Shopify?.routes?.root||'/')+'products/'+miniHandle.replace(/-mini$/,'');
      card.after(notice);
    }
    const guide = document.querySelector('#mini-guide');
    const story = document.querySelector('#mini-story');
    const opening = story?.querySelector('.ka-sunset-mini-story__inner');
    const guideGift = guide?.querySelector('#mini-gift');
    if (story && opening && guideGift) {
      const link = (caption, target, className) => {
        const a = document.createElement('a'); a.className = className; a.href = '#' + target; a.textContent = caption;
        a.addEventListener('click', event => {
          const targetNode = document.getElementById(target);
          if (!targetNode || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault(); targetNode.tabIndex = -1; targetNode.focus({ preventScroll: true });
          const offset = Math.max(0, ...[...document.querySelectorAll('.ss-topbar,header-container.is-sticky')].map(e=>['sticky','fixed'].includes(getComputedStyle(e).position)?e.getBoundingClientRect().height:0)) + 16;
          scrollTo({top:targetNode.getBoundingClientRect().top+scrollY-offset,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        });
        return a;
      };
      card.before(link('商品詳細は、ページ下部にあります↓','mini-story','ka-mini-details-link'));
      opening.append(link('↑ 購入欄へ戻る','ka-mini-purchase-options','ka-mini-purchase-return'));
      guideGift.before(link('↑ 購入欄へ戻る','ka-mini-purchase-options','ka-mini-purchase-return'));
    }
    for (const name of ['サイズ','額縁']) region.querySelector('input[name="'+name+'"]')?.closest('fieldset')?.classList.add('ka-mini-fixed-option');
    const normalized = label => label.replace(/\s*[＋+]\s*/g,' +').replaceAll('（','(').replaceAll('）',')').replaceAll('花・リボン付','リボン付').replace('ポップ(クマのタグ・リボン付)','ポップ(クマのタグ付)').replace(/[¥￥]([\d,]+)/g,'$1円');
    for (const option of [...wrapping.options,...noshi.options]) option.textContent = normalized(option.textContent.trim()).replace('ラッピング無し','ラッピングなし').replace('のし無し','のし不要');
    for(const [select,caption] of [[wrapping,'ラッピング'],[noshi,'のし'],[purchase.querySelector('[data-mini-purpose]'),'ご利用用途']]){
      const label=select?.closest('label')?.querySelector(':scope > span');if(label)label.textContent=caption;
    }
    const hint = document.createElement('p');hint.className='ka-mini-entry-hint';hint.textContent='※カートに進み記入';
    noshi.closest('label').after(hint);
    const syncHint=()=>{hint.hidden=noshi.value==='熨斗なし';};noshi.addEventListener('change',syncHint);syncHint();
    summary.querySelector('.ka-sunset-mini-purchase__summary-price dt').textContent='合計金額';
    gift.after(summary,points);
    // 9/27：数量欄を通常サイズと同じ「ご利用用途」の下（合計金額のすぐ上）へ（ka-artwork-purchase-cards.js と同じ動き）
    const quantity=region.querySelector('.product-single__box__block--quantity_selector');if(quantity&&quantity.nextElementSibling!==summary)summary.before(quantity);
    const pointValue=points.querySelector('[data-mini-points-value]');
    const pointLink=points.querySelector('a');
    if(pointValue){
      const label=document.createElement('span');label.className='ka-mini-points-label';label.textContent='［'+(points.dataset.poingpongRatePercent||'5')+'%還元';
      const link=document.createElement('a');link.className='ka-mini-points-value';link.href=pointLink?.getAttribute('href')||'/pages/member-points-guide';
      const amount=document.createElement('span');amount.append(pointValue,document.createTextNode('ポイント'));
      link.append(amount,document.createTextNode('］'));points.replaceChildren(label,link);
    }
    const dialog=document.createElement('dialog');dialog.className='ka-mini-entry-dialog';dialog.setAttribute('aria-label','のしの記載内容');
    dialog.innerHTML='<div class="ka-mini-entry-panel"><button type="button" class="ka-mini-entry-back">← 商品の選択に戻る</button><button type="button" class="ka-mini-entry-close" aria-label="入力画面を閉じる">×</button><h2 tabindex="-1">のしの記載内容</h2><p class="ka-mini-card-notice">※メッセージカード(封筒入り)をご希望の方は、カートの入力欄にご入力ください。</p><p class="ka-mini-entry-error" role="alert" hidden></p><button type="button" class="ka-mini-entry-add">この内容でカートに追加</button></div>';
    const panel=dialog.querySelector('.ka-mini-entry-panel');
    const heading=panel.querySelector('h2');heading.id='ka-mini-noshi-heading';
    noshiFields.classList.add('ka-mini-noshi-source');noshiInput.type='hidden';noshiInput.removeAttribute('placeholder');
    const splitFields=document.createElement('div');splitFields.className='ka-mini-noshi-parts';splitFields.setAttribute('role','group');splitFields.setAttribute('aria-labelledby',heading.id);
    splitFields.innerHTML='<label class="ka-mini-noshi-part"><span>表書き</span><input type="text" id="ka-mini-noshi-title-search" data-mini-noshi-title placeholder="例：御結婚御祝"></label><label class="ka-mini-noshi-part"><span>名前</span><input type="text" id="ka-mini-noshi-name-search" data-mini-noshi-name placeholder="例：鈴木"></label>';
    heading.after(noshiFields,splitFields);
    const titleInput=splitFields.querySelector('[data-mini-noshi-title]');
    const nameInput=splitFields.querySelector('[data-mini-noshi-name]');
    if(noshiInput.value.trim())titleInput.value=noshiInput.value.trim();
    purchase.append(dialog);
    for(const button of dialog.querySelectorAll('.ka-mini-entry-close,.ka-mini-entry-back'))button.addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){event.preventDefault();event.stopPropagation();}});
    const addButton=form.querySelector('button[name="add"]');
    const entryButton=dialog.querySelector('.ka-mini-entry-add');
    const error=dialog.querySelector('.ka-mini-entry-error');
    const giftError=purchase.querySelector('[data-mini-gift-error]');
    const syncSubmissionState=()=>{
      entryButton.disabled=Boolean(addButton?.disabled);
      if(dialog.open&&giftError&&!giftError.hidden&&giftError.textContent.trim()){
        error.textContent=giftError.textContent.trim();error.hidden=false;giftError.hidden=true;
      }
    };
    const stateObserver=new MutationObserver(syncSubmissionState);
    if(addButton)stateObserver.observe(addButton,{attributes:true,attributeFilter:['disabled']});
    if(giftError)stateObserver.observe(giftError,{attributes:true,attributeFilter:['hidden'],childList:true,subtree:true});
    // 「戻る」で復元されたときに小窓を閉じる・追加ボタンを戻す処理は ka-product.js の1か所にまとめた（9/26 段階3）
    let passing=false;
    const open=()=>{error.hidden=true;dialog.showModal();syncSubmissionState();panel.querySelector('h2').focus({preventScroll:true});};
    window.addEventListener('submit',event=>{
      if(event.target!==form||passing||noshi.value==='熨斗なし')return;
      event.preventDefault();event.stopImmediatePropagation();open();
    },true);
    window.addEventListener('click',event=>{
      if(passing||noshi.value==='熨斗なし'||!event.target.closest('button[name="add"]')||!form.contains(event.target))return;
      event.preventDefault();event.stopImmediatePropagation();open();
    },true);
    const syncNoshiParts=()=>{
      const parts=[];
      if(titleInput.value.trim())parts.push('表書き：'+titleInput.value.trim());
      if(nameInput.value.trim())parts.push('名前：'+nameInput.value.trim());
      noshiInput.value=parts.join('／');
      error.hidden=true;titleInput.removeAttribute('aria-invalid');nameInput.removeAttribute('aria-invalid');
    };
    for(const input of [titleInput,nameInput])input.addEventListener('input',syncNoshiParts);
    entryButton.addEventListener('click',()=>{
      if(entryButton.disabled)return;
      syncNoshiParts();
      if(!noshiInput.value){error.hidden=false;error.textContent='のしの表書き、またはお名前を入力してください。';titleInput.setAttribute('aria-invalid','true');titleInput.focus();return;}
      entryButton.disabled=true;passing=true;
      try{form.requestSubmit(addButton);}catch(_){entryButton.disabled=false;error.textContent='カートに追加できませんでした。時間をおいて、もう一度お試しください。';error.hidden=false;}
      finally{passing=false;syncSubmissionState();}
    });
    const shipping=region.querySelector('[data-ka-sunset-mini-shipping]');
    shipping?.querySelectorAll('p').forEach(row=>{if(row.querySelector('strong')?.textContent.trim()==='送料：')row.hidden=true;});
    if(addButton){const caption=addButton.querySelector('staged-action-text,.btn__text')||addButton;caption.textContent='カートに入れる';}
    return true;
  };
  if(!start()){
    const observer=new MutationObserver(()=>{if(start())observer.disconnect();});
    observer.observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['data-ready']});
  }
})();
// 9/23：のしの「名前」などで Safari が「連絡先を自動入力」を出して入力しづらいため、購入欄と入力の小窓の文字入力欄は自動入力の候補を出さない
(() => {
  const SCOPE = 'dialog, form[action*="/cart/add"], [data-hz-product-region], [data-mini-product-region]';
  const off = el => { if (el && el.matches && el.matches('input[type="text"], input:not([type]), textarea') && el.closest(SCOPE) && el.getAttribute('autocomplete') !== 'off') el.setAttribute('autocomplete', 'off'); };
  document.addEventListener('focusin', event => off(event.target), true);
  const sweep = () => document.querySelectorAll('input[type="text"], input:not([type]), textarea').forEach(off);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sweep); else sweep();
  [1000, 3000].forEach(ms => setTimeout(sweep, ms));
})();
